import theme from 'theme';

export default {
  '@global body': {
    backgroundColor: 'common.white',
  },
  customType1: {
    fontSize: theme.typography.pxToRem(20),
    lineHeight: theme.typography.pxToRem(26),
  },
  customType2: {
    fontSize: theme.typography.pxToRem(40),
    lineHeight: theme.typography.pxToRem(49),
    fontWeight: theme.typography.fontWeightBold,
  },
} as const;
